var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isEmptyListPlaceholderShown
    ? _c(
        "EmptyListPlaceholder",
        {
          attrs: { title: _vm.emptyListTitle, subtitle: _vm.emptyListSubtitle },
          scopedSlots: _vm._u(
            [
              {
                key: "image",
                fn: function () {
                  return [_c("EmptyListImageContractors")]
                },
                proxy: true,
              },
            ],
            null,
            false,
            143841379
          ),
        },
        [_vm._t("emptyListActions")],
        2
      )
    : _c(
        "div",
        [
          _vm.isListItemsExist
            ? _c("ActionsPanelWithFilters", {
                attrs: { total: _vm.total },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "filters",
                      fn: function () {
                        return [
                          _vm._t("filtersFullBlock", function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "flex" },
                                [
                                  _c("Search", {
                                    staticClass: "w-60 mr-4",
                                    on: { search: _vm.search },
                                  }),
                                  _vm._t("filters"),
                                ],
                                2
                              ),
                            ]
                          }),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "actions",
                      fn: function () {
                        return [_c("div", [_vm._t("actions")], 2)]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              })
            : _vm._e(),
          _c(
            "LoadingOverlay",
            { attrs: { hasData: _vm.isListItemsExist, loading: _vm.loading } },
            [
              _vm.isSearchResultEmpty
                ? _c("EmptyListPlaceholder", {
                    attrs: { title: _vm.emptySearchResultTitle },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "image",
                          fn: function () {
                            return [_c("EmptyListImageContractors")]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      143841379
                    ),
                  })
                : _c("div", [_vm._t("default")], 2),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }